import { useState, useEffect, useCallback } from "react";
import breakpoints from "../themes/mixins/responsive.scss";

function useResponsive() {
  const [responsiveDetails, setResponsiveDetails] = useState({
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight,
  });

  const handleResize = useCallback(() => {
    setResponsiveDetails({
      innerWidth: window.innerWidth,
      innerHeight: window.innerHeight,
    });
  }, []);
  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isXxl = responsiveDetails?.innerWidth > parseInt(breakpoints["xl-max"]);
  const isXl = responsiveDetails?.innerWidth > parseInt(breakpoints["lg-max"]);
  const isLg = responsiveDetails?.innerWidth > parseInt(breakpoints["md-max"]);
  const isMd = responsiveDetails?.innerWidth > parseInt(breakpoints["sm-max"]);
  const isSm = responsiveDetails?.innerWidth > parseInt(breakpoints["xs-max"]);
  const isXs = true;
  return {
    isXxl,
    isXl,
    isLg,
    isMd,
    isSm,
    isXs,
  };
}

export default useResponsive;
